
<template>
    <div class="menu-layout">
        <slot/>
    </div>
</template>

<style scoped>
.menu-layout
{
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.menu-layout :deep(.content)
{
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    width: 100%;
    max-width: var(--cr-main-content-width);
}

.menu-layout :deep(.objective)
{
    font-size: 0.95rem;
    color: var(--cr-splash-text);
    opacity: 0.8;
    text-align: center;
    line-height: 1.6;
    max-width: var(--cr-main-content-width);
}

.menu-layout :deep(.back)
{
    font-size: 0.85rem;
    font-weight: 700;
    color: var(--cr-splash-accent);
    border: 1px solid var(--cr-splash-accent-subtle);
    border-radius: var(--cr-pill-button-border-radius);
    text-decoration: none;
    letter-spacing: 0.05em;
}

.menu-layout :deep(.back:hover)
{
    background: var(--cr-splash-accent-subtle);
}
</style>